import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    h1: 'mb-6 text-2xl leading-[1.2] font-medium lg:text-3xl',
    top: 'bg-bg-items-dark text-text-main-inversion border-text-main-inversion flex items-center justify-between gap-4 border-b-2 px-3 py-6 lg:px-8 lg:py-5',
    topInfo: 'flex gap-3 lg:gap-4',
    topCount: 'text-text-inactive text-xs',
    topContent: 'flex flex-col gap-1',
    topTitle: 'text-s lg:text-m flex items-center gap-2 font-medium',
    topText: 'text-[12px]',
    content:
      'bg-bg-items-dark text-text-main-inversion border-text-main-inversion border-b-2 px-3 py-6 lg:p-8',
    levels:
      'grid grid-cols-3 gap-4 max-lg:flex max-lg:snap-x max-lg:snap-mandatory max-lg:grid-rows-1 max-lg:flex-nowrap max-lg:gap-2 max-lg:overflow-x-auto max-lg:[scrollbar-width:none] max-lg:[&::-webkit-scrollbar]:hidden',
    level:
      'flex min-h-39 flex-col justify-between bg-[#4F5051] p-6 text-[#A7A7A8] max-lg:w-[79vw] max-lg:shrink-0 max-lg:snap-start max-lg:snap-always',
    levelTitle:
      'text-m flex items-center justify-between leading-[140%] font-medium',
    levelInfo: 'flex items-end justify-between gap-2',
    levelBonuses: 'ga-2 flex flex-col items-stretch',
    levelLbl: 'text-[12px] leading-[140%] whitespace-nowrap',
    levelCashback: 'text-xs font-medium',
    levelNote: 'text-right text-[12px] leading-[140%] max-lg:max-w-[65%]',
    levelIcon: 'w-[30px] [&>path]:fill-white [&>path]:stroke-white',
    info: 'mt-8 mb-4 max-lg:text-xs lg:mt-7.5',
    line: 'relative h-[6px] overflow-hidden rounded-[100px] bg-[#4F5051]',
    heading:
      'mb-3 flex flex-col items-baseline justify-between gap-4 lg:flex-row lg:items-center lg:gap-0',
    headingSecond:
      'mb-5.5 flex flex-col items-baseline justify-between lg:flex-row lg:items-center',
    title: 'heading-xl lg:max-w-[60%]',
    subtitle: 'heading-s-bold mb-4 lg:mb-0',
    label: 'lg:mt-1',
    advantages: '',
    levelUpCards: '',
    historyLinkText:
      'group hover:text-brand-400 mt-7.5 flex cursor-pointer items-center gap-2 text-xs font-medium',
    historyLinkIcon:
      'group-hover:[&>path]:stroke-brand-400 -rotate-90 [&>path]:stroke-white',
    referral:
      'bg-bg-items-dark text-text-main-inversion flex items-start gap-5 px-3 py-6 max-lg:flex-col lg:items-center lg:gap-6 lg:p-8',
    referralInfo: 'flex flex-col gap-2',
    referralTitle: 'text-s lg:text-m font-medium',
    referralText: 'lg:text-s text-xs',
    referralBtn: 'hover:text-text-main w-full lg:w-[187px]',
    referralCode: 'w-full lg:w-auto',
    referralInput: 'border-b-text-main-inversion text-s w-full lg:w-[176px]'
  },
  variants: {
    active: {
      true: {
        level: 'text-text-main-inversion bg-brand-400'
      }
    },
    mode: {
      explorer: '',
      innovator: {
        line: 'after:bg-brand-400 after:absolute after:top-0 after:right-[75%] after:bottom-0 after:left-0 after:rounded-[100px]'
      },
      ambassador: {
        line: 'after:bg-brand-400 after:absolute after:top-0 after:right-0 after:bottom-0 after:left-0 after:rounded-[100px]'
      }
    }
  }
});
